import { WorkbookStatusEnum } from '../../graphql/private/PrivateSchemaTypes'

export const isTopicCompletedOutsidePathway = (
  currentEnrolmentStatus?: WorkbookStatusEnum | null,
  lastEnrolmentStatus?: WorkbookStatusEnum | null,
  lastEnrolmentCompletedAt?: string | null,
  pathwayCompletedAt?: string | null
) => {
  if (pathwayCompletedAt && lastEnrolmentCompletedAt) {
    return (
      currentEnrolmentStatus !== WorkbookStatusEnum.COMPLETED &&
      lastEnrolmentStatus === WorkbookStatusEnum.COMPLETED &&
      lastEnrolmentCompletedAt > pathwayCompletedAt
    )
  }
  return false
}
